(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("kJLhH", function(module, exports) {

$parcel$export(module.exports, "dualImage", function () { return $f18cb054898d9b67$export$149259a7a55602c2; });

var $lGVtm = parcelRequire("lGVtm");
var $dxivK = parcelRequire("dxivK");
const $f18cb054898d9b67$export$149259a7a55602c2 = (element)=>{
    const image = element.querySelector('img');
    const scrollOptions = {
        target: element,
        offset: [
            "25% end",
            "85% end"
        ]
    };
    if (window.matchMedia("(min-width: 1024px)").matches) (0, $dxivK.scroll)((0, $lGVtm.animate)(image, {
        clipPath: [
            "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            "polygon(0 0, 50% 0, 50% 100%, 0% 100%)"
        ]
    }), scrollOptions);
    else (0, $dxivK.scroll)((0, $lGVtm.animate)(image, {
        clipPath: [
            "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            "polygon(0 0, 0% 0, 0% 100%, 0% 100%)"
        ]
    }), scrollOptions);
};

});

parcelRegister("1BJop", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $12bc753290b100a8$export$f6e2535fb5126e54; });
const $12bc753290b100a8$export$f6e2535fb5126e54 = (value)=>typeof value === "function";

});

parcelRegister("jcurC", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $dfa6c0f8dc3dbbd0$export$90ceba2564a894f8; });
function $dfa6c0f8dc3dbbd0$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}

});

})();
//# sourceMappingURL=dual-image.c42a87ee.js.map
